import axios from "./api";

const PutyovkaYonalish = {

    /**
     * response looks like this
     * {
     *   "success": true,
     *   "message": "success",
     *   "data": [
     *     {
     *       "from_davlat": "Uzbekistan",
     *       "to_davlat": "Russia"
     *     }
     *   ]
     * }
     * @returns {Promise<any>}
     */
    async getYonalishList() {
        try {
            const response = await axios.get('/putyofka_yonalish');
            console.log('putyovka yonalish', response.data);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || 'Error getting userList';
        }
    },
}

export default PutyovkaYonalish